import React from 'react';

import { WebContent } from '@core/js/components/system/WebContent';

import { htcmdService } from '@core/js/services/htcmd.service';

import { useDynamicTags } from '@interlayer/js/custom/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/custom/utils/constants';

const DYNAMIC_TAGS = [DYNAMIC_TAG_NAMES.STICKY_MENU_WEBCONTENT_ID];

export const StickyMenuContainer = () => {
    const [dTagStickyMenuWebContentId] = useDynamicTags(DYNAMIC_TAGS);
    const isNative = htcmdService.isEnabled || htcmdService.isWrapperEnabled;

    if (!dTagStickyMenuWebContentId || isNative) {
        return null;
    }

    return (
        <WebContent
            showLoader={false}
            id={dTagStickyMenuWebContentId}
        />
    );
};
